import firehydrantAPI from 'helpers/firehydrantAPI';
import { createMutationHook } from 'queries/common';

export const useCreateSignalStream = createMutationHook((params) =>
  firehydrantAPI.post('signals_stream', params),
);
